import React from "react"

const PrimaryButton = ({
  children,
  onClick,
  type = "button",
  icon = null, // parent passes icon component
  style = {},
  ...rest
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      style={{
        padding: "15px 65px",
        backgroundColor: "#2990DF",
        color: "white",
        border: "none",
        borderRadius: "4px",
        cursor: "pointer",
        fontWeight: "400",
        fontSize: "1rem",
        fontFamily: "Inter",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "6px", // keeps spacing consistent between text + icon
        ...style,
      }}
      {...rest}
    >
      {children}
      {icon && <span>{icon}</span>}
    </button>
  )
}

export default PrimaryButton
